import React from "react";
import { FileX } from "lucide-react";
import { ReportingPeriodTimeline } from "../../reporting-periods";

export const NoReportingPeriodState: React.FC = () => {
  return (
    <div className="min-h-screen">
      <ReportingPeriodTimeline />
      
      <div className="container mx-auto px-6 py-12 max-w-4xl">
        <div className="flex flex-col items-center text-center space-y-6">
          <div className="p-4 bg-orange-100 rounded-full">
            <FileX className="h-12 w-12 text-orange-600" />
          </div>
          <div className="space-y-2">
            <h2 className="text-2xl font-bold text-slate-800">No Reporting Period Selected</h2>
            <p className="text-slate-600 max-w-md leading-relaxed">
              Please select a reporting period from the timeline above to view and manage rule exceptions for that period.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}; 